"use client";

import { Star } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Advocacy() {
  const v1 = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const v2 = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const v3 = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="2963" id="the-power-of-advocacy" className="bg-background py-32">
      <div className="mx-auto max-w-6xl px-6 lg:px-10">
        {}
        <div ref={v1.ref} className={`grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-center transition-all duration-1000 ease-out ${v1.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="md:col-span-6">
            <div className="overflow-hidden rounded-lg shadow-md">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723817/img/negotiation_strategy_session.png" alt="Professional consultant reviewing purchase documents with a client" loading="lazy" decoding="async" className="w-full h-full aspect-square object-cover" />
            </div>
          </div>
          <div className="md:col-span-6 flex flex-col justify-center">
            <span className="font-default text-xs font-bold uppercase tracking-[0.2em] text-[var(--brand-accent)] mb-6">
              Phase I · Strategic Planning
            </span>
            <h2 className="font-default font-bold uppercase text-[2.5rem] leading-[1.1] text-[var(--brand-deep)] mb-8">
              Precision in every purchase.
            </h2>
            <p className="font-default text-lg leading-relaxed text-[var(--text-main)] max-w-md">
              Every major acquisition begins with a clear strategy. We analyze market data, 
              identify leverage points, and prepare a tactical roadmap. Our approach ensures 
              you enter every negotiation with the confidence of an expert, turning complex 
              transactions into straightforward wins.
            </p>
          </div>
        </div>

        {}
        <div className="flex justify-center my-32">
          <Star className="h-4 w-4 text-[var(--brand-accent)] opacity-60" strokeWidth={1} />
        </div>

        {}
        <div ref={v2.ref} className={`grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-center transition-all duration-1000 ease-out ${v2.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="md:col-span-5 md:order-1 order-2 flex flex-col justify-center md:pl-20">
            <span className="font-default text-xs font-bold uppercase tracking-[0.2em] text-[var(--brand-accent)] mb-6">
              Phase II · Expert Negotiation
            </span>
            <h2 className="font-default font-bold uppercase text-[2.5rem] leading-[1.1] text-[var(--brand-deep)] mb-8">
              Your voice at the table.
            </h2>
            <p className="font-default text-lg leading-relaxed text-[var(--text-main)]">
              <span className="font-default float-left text-7xl leading-[0.85] pr-3 pt-1 text-[var(--brand-accent)]">
                W
              </span>
              e act as your dedicated advocate, navigating the nuances of high-stakes 
              purchases. By removing the emotional burden and applying proven negotiation 
              frameworks, we secure terms that protect your interests and maximize your 
              financial outcome. You focus on the goal; we handle the details.
            </p>
          </div>
          <div className="md:col-span-7 md:order-2 order-1">
            <div className="overflow-hidden rounded-lg shadow-md">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723817/img/client_consultation_meeting.png" alt="Consultant and client discussing negotiation outcomes" loading="lazy" decoding="async" className="w-full aspect-[4/3] object-cover" />
            </div>
          </div>
        </div>

        {}
        <div className="flex justify-center my-32">
          <Star className="h-4 w-4 text-[var(--brand-accent)] opacity-60" strokeWidth={1} />
        </div>

        {}
        <div ref={v3.ref} className={`mx-auto max-w-2xl transition-all duration-1000 ease-out ${v3.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="overflow-hidden rounded-lg shadow-md mb-12">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723817/img/successful_transaction_outcome.png" alt="Happy client shaking hands after a successful purchase" loading="lazy" decoding="async" className="w-full aspect-[16/6] object-cover" />
          </div>

          <div className="text-center">
            <span className="font-default text-xs font-bold uppercase tracking-[0.2em] text-[var(--brand-accent)] mb-6 inline-block">
              Phase III · Proven Results
            </span>
            <h2 className="font-default font-bold uppercase text-[2.5rem] leading-[1.1] text-[var(--brand-deep)] mb-8">
              Value delivered, peace of mind.
            </h2>
            <p className="font-default text-lg leading-relaxed text-[var(--text-main)] mb-12">
              Our success is measured by the savings and security we provide to our clients. 
              From initial consultation to final signature, we ensure transparency, 
              integrity, and exceptional results. We are your partners in every significant 
              financial decision.
            </p>

            <div className="flex justify-center mb-10">
              <div className="w-12 h-px bg-[var(--brand-mid)]" />
            </div>

            <blockquote className="font-default italic text-2xl md:text-[1.75rem] leading-snug text-[var(--brand-deep)] mb-6">
              "Price Advocate Services turned a stressful purchase into a seamless, 
              profitable experience."
            </blockquote>
            <cite className="font-default not-italic text-xs font-bold uppercase tracking-[0.2em] text-[var(--text-muted)]">
              — Founder, Price Advocate Services
            </cite>
          </div>
        </div>
      </div>
    </section>;
}